export const PAY_OR_GO_SETTINGS = {
  id: '401018616',
  permission: 'tvmedia:pur',
  alertMessage: 'Wir speichern keine personenbezogenen Cookies von Ihnen, da Sie ein PUR-Abo besitzen',
};
